export interface PageViewData {
  page_location: string | undefined;
  page_title: string | undefined;
  country: string | null;
  language: string | null;
  logged_in: boolean;
  plan_type?: string | undefined;
  user_purpose?: string | undefined;
}

export interface TrackedCheckoutT {
  transaction_id: string;
  value: number; // Total purchase value excluding tax
  coupon?: string | undefined;
  currency: string;
  item_name: string;
  item_discount?: number | undefined;
  item_price: number; // Total excluding tax / quantity
  quantity: number;
  payment_method: string;
}

export const PlanTypeMap = {
  free: 'c5629dde-a12d-435f-8401-206e8ac7d233',
  teams: 'b9e11283-fbe9-44c9-9504-e624e900dc1c',
  basic: 'f1b97b9a-2956-4ab5-9c93-79260a660bb2',
  'basic-monthly': 'd07081ee-6da3-45cb-94a0-95b3e203f555',
  pro: 'a9c84d80-2a27-4671-b992-91b954d5d0f9',
  'educational-basic': '413a8563-1f1d-4d9e-85ab-c4a3b0005503',
  'educational-basic-monthly': '948d7fc8-843b-40ba-bfa0-d7dd45ae1402',
  'educational-pro': '0813972c-4587-4e6e-8633-dd850262e7d0',
  'student-pro': '7c26c998-b158-4d6a-8b00-eba886c7f07a',
  'conference-small': '9e7fcaa4-aed5-482f-bfb8-abb77fce8317',
  'conference-large': '159d28cb-5e3f-46c4-9115-6c6b91418aa2',
  enterprise: '6d6344d4-746c-4cc6-b05d-284aacc6e786',
  'pro-trial': '03018728-6b9d-441c-8a7c-5ac0b6c97713',
  'enterprise-trial': '323f411f-a42b-4324-8f59-f31de0d464c0',
  invoice: '27d337c0-c96c-46be-848d-9c0b1cc720e4',
} as const;

export type PlanType = keyof typeof PlanTypeMap;

interface BaseItem {
  discount?: number | undefined; // Discount per item
  price: number; // Per item list price minus discount
  quantity: number;
}

type ItemT = {
  item_name: keyof typeof PlanTypeMap; // Key from PlanTypeMap
  item_id: (typeof PlanTypeMap)[keyof typeof PlanTypeMap]; // Use the value from PlanTypeMap
} & BaseItem;

export type ECommerceType =
  | 'new' // First time purchase
  | 'additional_licenses' // Adding additional licenses
  | 'upgrade' // Upgrade from basic to pro
  | 'change_billing_cycle'; // Change billing cycle from monthly to yearly

export type PaymentType = 'card' | 'paypal';

export interface PurchaseT {
  event: 'purchase';
  ecommerce: {
    transaction_id: string;
    value: number; // Total purchase value excluding tax
    currency: string;
    coupon?: string | undefined; // only applicable for first time purchase
    type: ECommerceType;
    payment_type: PaymentType;
    items: [ItemT];
  };
}
